module.exports = __webpack_public_path__ + "img/swiper-bg1.90ed7400.png";